import InfoTag from "../infoTag.infoBar.component";

const CountInfoTag = ({ children }) => {
  return (
    <InfoTag>
      <div className="flex px-2 py-1 justify-center h-full w-full items-center font-ubuntuRegular">
        {children}
      </div>
    </InfoTag>
  );
};

export default CountInfoTag;
